frappe.provide("pms.setup_file_upload_sec");
// Functions to add custom file upload Section,
// Fieldname custom_file_upload_section with fieldtype section break should be present.
pms.setup_file_upload_sec.render_file_section = function (d) {
	let attach_btn = `
    <div class="form-column col-sm-2">
        <form>
            <div class="frappe-cont input-max-width">
                <label for="fileInput" class="btn btn-secondary btn-sm">+ Add Files</label>
                <input type="file" id="fileInput" data-fieldname="attachment"
                    accept=".doc,.docx,.dot,.dotx,.pdf,.txt,.jpg,.jpeg,.png,.mp4,.webm,.mkv,.avi,.wmv,.xls,.xlsx,.csv,.ppt,.pptx"
                    multiple style="display: none;">
            </div>
        </form>
    </div>
    <div class="form-column col-sm-10">
        <form>
            <div class="frappe-control" style="max-height: 120px; overflow-y: auto; padding: 10px;">
                <div id="filePreview">No File selected</div>
            </div>
            <button id="clearFiles" class="btn btn-danger btn-sm" style="display: none; margin-top: 10px;">Clear</button>
        </form>
    </div>`;

	if (d.fields_dict["custom_file_upload_section"]?.df?.fieldtype === "Section Break") {
		let $btn = $(attach_btn);
		d.fields_dict["custom_file_upload_section"].body.append($btn);

		$(document).on("change", "#fileInput", function (event) {
			let files = (d.selected_files = event.target.files);
			let filePreview = $("#filePreview");
			let clearButton = $("#clearFiles");
			filePreview.empty();

			if (files.length > 0) {
				clearButton.show();
				for (let i = 0; i < files.length; i++) {
					let file = files[i];
					filePreview.append(`<div style="padding: 5px;">
                        <svg class="icon icon-sm"><use href="#icon-attachment"></use></svg>
                        ${file.name} (${(file.size / 1024).toFixed(2)} KB)
                    </div>`);
				}
			} else {
				filePreview.text("No files selected.");
				clearButton.hide();
			}
		});

		$(document).on("click", "#clearFiles", function (event) {
			event.preventDefault();
			$("#fileInput").val("");
			$("#filePreview").text("No files selected.");
			$("#clearFiles").hide();
			d.selected_files = null;
		});
	}
};

pms.setup_file_upload_sec.upload_file = function (files, id, doctype) {
	let formData = new FormData();
	formData.append("file", files);
	formData.append("is_private", 1);
	formData.append("doctype", doctype);
	formData.append("docname", id);

	return new Promise((resolve, reject) => {
		$.ajax({
			url: "/api/method/upload_file",
			type: "POST",
			data: formData,
			contentType: false,
			processData: false,
			headers: {
				"X-Frappe-CSRF-Token": frappe.csrf_token,
			},
			success: function (response) {
				resolve(response);
			},
			error: function (error) {
				frappe.msgprint(__(files.name + ": " + error.responseJSON.exception));
				reject(error);
			},
		});
	});
};
